import React, { useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import FormCheckInput from "react-bootstrap/esm/FormCheckInput";
import EmailCell from "./EmailCell";
import Message from "./Message";
import { FaPlus, FaPlusCircle } from "react-icons/fa";
import permissions from "../data/permissions";
import { notify } from "./notify";
import SimpleToast from "./SimpleToast";
import { MdHelpOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { logout } from "../actions/userActions";

const MemberForm = ({ clinicId }) => {
  const [memberEmail, setMemberEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [permissionId, setPermissionId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const handleAddMember = async () => {
    if (!memberEmail || !permissionId) {
      notify({
        title: "Edit Warning",
        message: (
          <p className="lead">
            All inputs are required
            <br /> Kindly, compelete data and click again
          </p>
        ),
        type: "info",
        duration: 3000,
      });
      return;
    }

    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/clinics/${clinicId}/addNewClinicMember`,
        { memberEmail, permissionId },
        config,
      );
      if (data.message === "Member added successfully") {
        dispatch({ type: "CLINIC_DETAILS_RESET" });
        setLoading(false);

        notify({
          title: "Member added successfully",
          message: <p className="lead">Data saved.</p>,
          type: "success",
          duration: 4000,
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };

  return (
    <Card className=" border-primary mb-3">
      <Card.Header className="text-center text-primary">
        <Card.Title>ADD NEW MEMBER</Card.Title>
      </Card.Header>
      <Card.Body>
        <>
          <Form.Group controlId="memberEmail">
            <Form.Label>Member Email</Form.Label>
            <EmailCell
              email={memberEmail}
              setEmail={setMemberEmail}
              emailError={emailError}
              setEmailError={setEmailError}
            />
          </Form.Group>
          <Form.Group controlId="permissionId">
            <Form.Label>Permission</Form.Label>
            <Form.Control
              as="select"
              value={permissionId}
              onChange={(e) => setPermissionId(e.target.value)}
              className="custom-select"
              isValid={permissionId}
            >
              {permissions.map((p) => (
                <option key={p._id} disabled={p.disabled} value={p._id}>
                  {p.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Message children={error} variant={`danger`} setMessage={setError} />

          <Form.Group className="text-right mr-5">
            <Button
              disabled={!memberEmail || !!emailError} // Disable button if email is invalid or empty
              onClick={handleAddMember}
              variant="outline-primary"
            >
              <FaPlusCircle /> ADD MEMBER
            </Button>
          </Form.Group>
        </>
      </Card.Body>
    </Card>
  );
};

export default MemberForm;
